import DotLegalTabs from "../../common/components/dotLegalTabs/DotLegalTabs.tsx";
import React, { useState } from "react";
import { dotLegalTabStyles } from "../../common/components/dotLegalTabs/DotLegalTabs.styles.ts";
import PlanUpgradeDialogWrapper from "../planUpgradeDialogWrapper/PlanUpgradeDialogWrapper.tsx";
import { TabContent } from "../../common/components/dotLegalTabs/DotLegalTabs.types.ts";

export interface PlanTabContent extends TabContent {
    disableAccess?: boolean;
}

export interface PlanTabsProps {
    fullWidth: boolean;
    tabStyle: dotLegalTabStyles;
    noPadding?: boolean;
    content: Array<PlanTabContent>;
    setSelectedTab: (index: number) => void;
    selectedTab: number;
    ignoreTextTransformation?: boolean;
}

function PlanTabs(props: PlanTabsProps) {
    const [showUpgradeDialog, setShowUpgradeDialog] = useState<TabContent | undefined>(undefined);

    const currentTabEntry = props.content.find((t) => t.index === props.selectedTab);
    const isCurrentTabAccessible = currentTabEntry && !currentTabEntry.disableAccess;
    const firstAccessibleTab = props.content.find((t) => !t.disableAccess);
    const validatedSelectedTab = isCurrentTabAccessible ? props.selectedTab : (firstAccessibleTab?.index ?? 0);

    const onSetSelectedTab = (index: number) => {
        let tabContent = props.content.find((x) => x.index === index)!;
        if (tabContent.disableAccess) {
            setShowUpgradeDialog(tabContent);
        } else {
            props.setSelectedTab(index);
        }
    };

    return (
        <>
            <DotLegalTabs
                {...props}
                selectedTab={validatedSelectedTab}
                setSelectedTab={(val) => {
                    onSetSelectedTab(val);
                }}
            />

            {showUpgradeDialog && <PlanUpgradeDialogWrapper text={showUpgradeDialog.tooltip!} onDialogClose={() => setShowUpgradeDialog(undefined)} />}
        </>
    );
}

export default PlanTabs;
